<template>
  <section>
    <div v-if="isImageFile(message)">
      <div class="chat-image-item">
        <div class="fade-in mb-2 relative"
            v-for="(attachment, index) in message.attachments"
            :key="index">
            <div class="form-check-input-group py-1 d-flex align-items-center justify-content-center" style="gap: 5px;">
              <div @click="downloadFile(attachment)"><i class="fa-solid fa-download cursor-pointer" ></i></div>
              <input type="checkbox"
              :id="'attachment-' + index"
              :value="attachment.url"
              :checked="isAttachmentSelected(attachment)"
              @change="selectedAttachmentDownload(attachment, $event.target.checked)">
            </div>
          <img @click="setSelectedAttachment(attachment)" :src="attachment.url" class="img-fluid rounded-lg" @load="handleLoad()">
        </div>
        <div class="text-chat-time" v-if="checkFacebookAds(message)">{{ checkFacebookAds(message) }}</div>
      </div>
      <div class="text-remark" v-if="!message.own && departmentIds.includes(admin.department_id)">
        <div class="pt-2">
          <button class="btn btn-outline-primary rounded-pill btn-sm" @click="sendPhotoToAiAssistant(message)">
            <i class="fas fa-image"></i> ให้ AI วิเคราะห์รูป
          </button>
        </div>
      </div>
    </div>
    <div v-else-if="getUrlExtension(message) === 'mp4'">
      <div class="card chat-media-item"
           :class="{ 'float-right' : message.own === 1 }">
        <div class="card-body p-2 relative">
          <div class="form-check-input-group py-1 d-flex align-items-center justify-content-center" style="gap: 5px;">
            <div @click="downloadFile(message.attachments[0])"><i class="fa-solid fa-download cursor-pointer" ></i></div>
            <input type="checkbox"
            :id="'attachment-' + message.id"
            :value="message.attachments[0].url"
            :checked="isAttachmentSelected(message.attachments[0])"
            @change="selectedAttachmentDownload(message.attachments[0], $event.target.checked)">
          </div>
          <vue-plyr>
            <video
              :src="message.attachments[0].url"
              format="audio/mp4"
            ></video>
          </vue-plyr>
          <div class="pt-2">
            <a :href="message.attachments[0].url" target="_blank">
              {{ message.attachments[0].url }}
            </a>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
    <div v-else-if="getUrlExtension(message) === 'mp3'">
      <div class="card chat-media-item">
        <div class="card-body p-2 relative">
          <div class="form-check-input-group py-1 d-flex align-items-center justify-content-center" style="gap: 5px;">
            <div @click="downloadFile(message.attachments[0])"><i class="fa-solid fa-download cursor-pointer" ></i></div>
            <input type="checkbox"
            :id="'attachment-' + message.id"
            :value="message.attachments[0].url"
            :checked="isAttachmentSelected(message.attachments[0])"
            @change="selectedAttachmentDownload(message.attachments[0], $event.target.checked)">
          </div>
          <vue-plyr>
            <audio
              :src="message.attachments[0].url"
              format="audio/mp3"
            ></audio>
          </vue-plyr>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="card customer-chat chat-media-item" v-if="message.message === '<Location>'">
        <div class="card-body p-2">
          <div class="embed-responsive embed-responsive-16by9">
            <div class="embed-responsive-item">
              <gmap-map
                :center="getLatLon(message)"
                :zoom="14"
                style="width: 100%; height: 100%;">
                <gmap-marker
                  :position="getLatLon(message)"
                />
              </gmap-map>
            </div>
          </div>
          <div class="pt-2" v-if="message.orig_message.message.address">
            {{ message.orig_message.message.address }}
          </div>
        </div>
      </div>
      <div v-else>
        <div class="card border-0 mw-100 mr-5"
             :class="[message.admin ? 'admin-chat' : 'customer-chat']">
          <div class="card-body text-small p-2">
            <a :href="message.attachments[0].url"
               target="_blank"
               class="linkified">
              {{ message.attachments[0].url }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue'
import { mapState, mapActions } from 'vuex'
import chatHelpers from '../../helpers/chatHelpers'

// Shared by every instance: one counter so each press gets a token no earlier press can match.
let visionToken = 0

export default {
  props: {
    message: Object,
    selectedFile: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState('admin', ['admin']),
    ...mapState('aiAssistant', ['adminIds', 'departmentIds']),
    ...mapState('conversation', ['customer'])
  },
  methods: {
    ...mapActions('aiAssistant', ['callAiVision']),
    selectedAttachmentDownload (attachment, isChecked) {
      // console.log('Attachment selected:', attachment, 'Checked:', isChecked)
      this.$emit('onSelectAttachment', attachment, isChecked)
    },
    isAttachmentSelected (attachment) {
      return this.selectedFile && this.selectedFile.length > 0 ? this.selectedFile.some(file => file.id === attachment.id) : false
    },
    async downloadFile (attachment) {
      let newformantData = {
        name: attachment.name,
        url: attachment.url
      }
      await this.ApiDonwloadFile(newformantData)
    },
    async ApiDonwloadFile (data) {
      window.open(`${Vue.prototype.$apiUrl}/download-image?data=${encodeURIComponent(JSON.stringify(data))}`, '_blank')
    },
    getLatLon (message) {
      return {
        lat: Number(message.orig_message.message.latitude),
        lng: Number(message.orig_message.message.longitude)
      }
    },
    checkFacebookAds (message) {
      let adsInfo = null
      if (message.orig_message && message.orig_message.messaging && message.orig_message.messaging[0].referral) {
        const referral = message.orig_message.messaging[0].referral
        adsInfo = `FB Ads: ${referral.ad_id}`
      }
      return adsInfo
    },
    handleLoad () {
      this.$store.commit('message/COUNT_LOADED_IMAGE')
    },
    isImageFile (message) {
      const ext = this.getUrlExtension(message)
      return (['jpg', 'jpeg', 'png', 'gif'].indexOf(ext) >= 0)
    },
    getUrlExtension (message) {
      return chatHelpers.getUrlExtension(message.attachments[0].url)
    },
    setSelectedAttachment (attachment) {
      this.$emit('onClickAttachment', attachment)
    },
    sendPhotoToAiAssistant (message) {
      if (message.attachments[0]) {
        this.$store.commit('aiAssistant/SET_ASSISTANT_FEATURE', 'image_description')
        const photoUrl = message.attachments[0].url
        const submitData = {
          photo_url: photoUrl,
          user_id: (this.customer && this.customer.customer) ? this.customer.customer.id : null,
          email: (this.customer && this.customer.customer) ? this.customer.customer.email : null
        }
        // Fires the panels' watcher on every press, so the right panel jumps to the AI tab even
        // when the same image is analysed twice.
        this.$store.commit('aiAssistant/SET_VISION_REQUEST', {
          token: ++visionToken,
          photoUrl: photoUrl,
          submitData: submitData
        })
        this.$store.dispatch('aiAssistant/callAiVision', submitData)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.form-check-input-group {
  z-index: 10;
  position: absolute;
  right: 0;
  background: #ffffff99;
  padding: 0 5px;
  border-radius: 0 0 0 10px;
}

</style>
